import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { panelHeader, panelTitle, panelSubtext } from './styles/styles.module.scss';

const { CREATE_A_CUSTOM_MAP, EASILY_PLAN_THE_PERFECT_PATH } = StringConstantsMixin.strings.MAP_CREATOR;

const EditHeader = () => {
  return (
    <div className={panelHeader}>
      <h1 className={panelTitle}>{CREATE_A_CUSTOM_MAP}</h1>
      <p className={panelSubtext}>{EASILY_PLAN_THE_PERFECT_PATH}</p>
    </div>
  );
};

export default EditHeader;
